var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBank = function SvgBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68945 11.019H27.4409V27.5708H4.68945V11.019Z",
    fill: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3794 11.9846H29.2415V26.4216H25.3794V11.9846Z",
    fill: "#D1D4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62036 26.1646H2.7583V12.49H6.62036V26.1646Z",
    fill: "#D1D4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2759 10.7432H30.3447V12.1226C30.3447 12.7319 29.8508 13.2258 29.2415 13.2258H25.3794C24.7698 13.2258 24.2759 12.7319 24.2759 12.1226V10.7432Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3794 25.3638H29.2415C29.8508 25.3638 30.3447 25.8579 30.3447 26.4673V27.8467H24.2759V26.4673C24.2759 25.8579 24.7698 25.3638 25.3794 25.3638Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62061 13.2258H2.75854C2.14917 13.2258 1.65527 12.7319 1.65527 12.1226V10.7432H7.72412V12.1226C7.72412 12.7319 7.23022 13.2258 6.62061 13.2258Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72412 27.8467H1.65527V26.4673C1.65527 25.8579 2.14917 25.3638 2.75854 25.3638H6.62061C7.23022 25.3638 7.72412 25.8579 7.72412 26.4673V27.8467Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.10352 8.09497H31.4482V10.4673C31.4482 10.772 31.2012 11.019 30.8965 11.019H1.65527C1.35059 11.019 1.10352 10.772 1.10352 10.4673V8.09497Z",
    fill: "#748CAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65527 27.5708H30.8965C31.2012 27.5708 31.4482 27.8179 31.4482 28.1226V30.8811H1.10352V28.1226C1.10352 27.8179 1.35059 27.5708 1.65527 27.5708Z",
    fill: "#748CAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4482 8.81226H0.551758C0.247071 8.81226 2.8525e-07 8.56519 2.8525e-07 8.2605V5.35669C-0.000243855 5.11548 0.15625 4.9021 0.386231 4.82983L15.5095 0.136963C15.8291 0.0375977 16.1709 0.0375977 16.4905 0.136963L31.6138 4.82983C31.8438 4.9021 32.0002 5.11548 32 5.35669V8.2605C32 8.56519 31.7529 8.81226 31.4482 8.81226Z",
    fill: "#18379A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20654 6.60522V6.57593L15.8342 2.34595C15.9407 2.31299 16.0544 2.31299 16.1609 2.34595L29.793 6.57593V6.60522H2.20654Z",
    fill: "#748CAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0688 19.2949C22.0688 22.6467 19.3518 25.3638 16 25.3638C12.6482 25.3638 9.93115 22.6467 9.93115 19.2949C9.93115 15.9431 12.6482 13.2258 16 13.2258C19.3518 13.2258 22.0688 15.9431 22.0688 19.2949Z",
    fill: "#7ED09E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.551758 29.7776H31.4482C31.7529 29.7776 32 30.0247 32 30.3293V31.4329C32 31.7375 31.7529 31.9846 31.4482 31.9846H0.551758C0.24707 31.9846 0 31.7375 0 31.4329V30.3293C0 30.0247 0.24707 29.7776 0.551758 29.7776Z",
    fill: "#18379A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank.8808228a.svg";
export { ForwardRef as ReactComponent };